import { useTranslation } from 'react-i18next'

import type { ProfileStatus, WorkerStatusAsAdmin } from '@front/type/worker'

export const APPLICATION_STATUS_MAPPING: WorkerStatusAsAdmin[] = [
  'employee',
  'tempWorker',
  'employeeMarketplace',
  'tempWorkerMarketplace',
  'tempAgency',
  'pool',
]

export const useStatusTranslation = (status: ProfileStatus) => {
  const { t } = useTranslation('network.status')
  const STATUS_TRANSLATIONS = {
    SALARIE: t('employee'),
    VACATAIRE: t('temp'),
    NETWORK: t('employee_marketplace'),
    MARKETPLACE: t('temp_agency'),
    TEMPORARY: t('temp_agency'),
    HUBLO_POOL: t('pool'),
  }
  return STATUS_TRANSLATIONS[status]
}
